module.exports = __webpack_public_path__ + "static/forecast/forecast-sunset-6442a89df78d41796a7def62fc051f1c.svg";